// Configuración de plantillas para exportación a Excel
// Este archivo contiene todas las configuraciones personalizables para Excel

const excelTemplates = {
  // Plantilla estándar
  standard: {
    nombre: 'Estándar',
    descripcion: 'Formato básico de presupuesto',

    // Configuración de estilos
    estilos: {
      titulo: {
        fontSize: 16,
        bold: true,
        alignment: { horizontal: 'center' },
        fill: { fgColor: { rgb: 'FFE5E5E5' } }
      },
      encabezado: {
        fontSize: 12,
        bold: true,
        alignment: { horizontal: 'center' },
        fill: { fgColor: { rgb: 'FF4472C4' } },
        font: { color: { rgb: 'FFFFFFFF' } }
      },
      celda: {
        fontSize: 10,
        alignment: { horizontal: 'left' }
      },
      numero: {
        fontSize: 10,
        alignment: { horizontal: 'right' },
        numFmt: '#,##0.00'
      },
      moneda: {
        fontSize: 10,
        alignment: { horizontal: 'right' },
        numFmt: '$#,##0.00'
      },
      porcentaje: {
        fontSize: 10,
        alignment: { horizontal: 'right' },
        numFmt: '0.00%'
      },
      subtotal: {
        fontSize: 11,
        bold: true,
        alignment: { horizontal: 'right' },
        fill: { fgColor: { rgb: 'FFF2F2F2' } }
      },
      total: {
        fontSize: 12,
        bold: true,
        alignment: { horizontal: 'right' },
        fill: { fgColor: { rgb: 'FFE5E5E5' } },
        numFmt: '$#,##0.00'
      }
    },

    // Configuración de columnas
    columnas: {
      anchos: {
        codigo: 15,
        descripcion: 50,
        unidad: 10,
        cantidad: 12,
        precioUnitario: 15,
        importe: 18
      },
      visibles: {
        partida: true,
        codigo: true,
        descripcion: true,
        unidad: true,
        cantidad: true,
        precioUnitario: true,
        importe: true
      }
    },

    // Configuración de secciones
    secciones: {
      encabezado: {
        mostrar: true,
        incluirLogo: false,
        campos: [
          { campo: 'nombre_obra', etiqueta: 'Obra:', fila: 3 },
          { campo: 'cliente', etiqueta: 'Cliente:', fila: 4 },
          { campo: 'ubicacion', etiqueta: 'Ubicación:', fila: 5 },
          { campo: 'fecha_elaboracion', etiqueta: 'Fecha:', fila: 6, formato: 'fecha' }
        ]
      },
      conceptos: {
        inicioFila: 8,
        encabezados: ['Código', 'Descripción', 'Unidad', 'Cantidad', 'P.U.', 'Importe']
      },
      totales: {
        mostrar: true,
        campos: [
          { campo: 'costoDirecto', etiqueta: 'Costo Directo:', mostrar: true },
          { campo: 'indirectos', etiqueta: 'Indirectos', mostrarPorcentaje: true },
          { campo: 'financiamiento', etiqueta: 'Financiamiento', mostrarPorcentaje: true },
          { campo: 'utilidad', etiqueta: 'Utilidad', mostrarPorcentaje: true },
          { campo: 'subtotal', etiqueta: 'Subtotal:', mostrar: true },
          { campo: 'iva', etiqueta: 'IVA', mostrarPorcentaje: true },
          { campo: 'total', etiqueta: 'TOTAL:', mostrar: true, resaltar: true }
        ]
      },
      piePagina: {
        mostrar: true,
        texto: 'Generado por Sistema de Presupuestación v2.0'
      }
    }
  },

  // Plantilla detallada (con análisis de precios unitarios)
  detallada: {
    nombre: 'Detallada con Análisis',
    descripcion: 'Incluye desglose de precios unitarios',

    estilos: {
      titulo: {
        fontSize: 16,
        bold: true,
        alignment: { horizontal: 'center' },
        fill: { fgColor: { rgb: 'FFE5E5E5' } }
      },
      encabezado: {
        fontSize: 12,
        bold: true,
        alignment: { horizontal: 'center' },
        fill: { fgColor: { rgb: 'FF4472C4' } },
        font: { color: { rgb: 'FFFFFFFF' } }
      },
      celda: {
        fontSize: 10,
        alignment: { horizontal: 'left' }
      },
      numero: {
        fontSize: 10,
        alignment: { horizontal: 'right' },
        numFmt: '#,##0.00'
      },
      moneda: {
        fontSize: 10,
        alignment: { horizontal: 'right' },
        numFmt: '$#,##0.00'
      },
      porcentaje: {
        fontSize: 10,
        alignment: { horizontal: 'right' },
        numFmt: '0.00%'
      },
      subtotal: {
        fontSize: 11,
        bold: true,
        alignment: { horizontal: 'right' },
        fill: { fgColor: { rgb: 'FFF2F2F2' } }
      },
      total: {
        fontSize: 12,
        bold: true,
        alignment: { horizontal: 'right' },
        fill: { fgColor: { rgb: 'FFE5E5E5' } },
        numFmt: '$#,##0.00'
      },
      analisis: {
        fontSize: 9,
        alignment: { horizontal: 'left' },
        fill: { fgColor: { rgb: 'FFFFF9E6' } }
      }
    },

    columnas: {
      anchos: {
        codigo: 15,
        descripcion: 45,
        unidad: 10,
        cantidad: 12,
        precioUnitario: 15,
        importe: 18,
        materiales: 15,
        manoObra: 15,
        maquinaria: 15
      },
      visibles: {
        partida: true,
        codigo: true,
        descripcion: true,
        unidad: true,
        cantidad: true,
        precioUnitario: true,
        importe: true,
        desglose: true
      }
    },

    secciones: {
      encabezado: {
        mostrar: true,
        incluirLogo: false,
        campos: [
          { campo: 'nombre_obra', etiqueta: 'Obra:', fila: 3 },
          { campo: 'cliente', etiqueta: 'Cliente:', fila: 4 },
          { campo: 'ubicacion', etiqueta: 'Ubicación:', fila: 5 },
          { campo: 'fecha_elaboracion', etiqueta: 'Fecha:', fila: 6, formato: 'fecha' }
        ]
      },
      conceptos: {
        inicioFila: 8,
        encabezados: ['Código', 'Descripción', 'Unidad', 'Cantidad', 'P.U.', 'Importe', 'Materiales', 'M.O.', 'Maquinaria'],
        incluirAnalisis: true
      },
      totales: {
        mostrar: true,
        campos: [
          { campo: 'costoDirecto', etiqueta: 'Costo Directo:', mostrar: true },
          { campo: 'indirectos', etiqueta: 'Indirectos', mostrarPorcentaje: true },
          { campo: 'financiamiento', etiqueta: 'Financiamiento', mostrarPorcentaje: true },
          { campo: 'utilidad', etiqueta: 'Utilidad', mostrarPorcentaje: true },
          { campo: 'subtotal', etiqueta: 'Subtotal:', mostrar: true },
          { campo: 'iva', etiqueta: 'IVA', mostrarPorcentaje: true },
          { campo: 'total', etiqueta: 'TOTAL:', mostrar: true, resaltar: true }
        ]
      },
      piePagina: {
        mostrar: true,
        texto: 'Generado por Sistema de Presupuestación v2.0'
      }
    }
  },

  // Plantilla simplificada
  simplificada: {
    nombre: 'Simplificada',
    descripcion: 'Formato compacto sin detalles',

    estilos: {
      titulo: {
        fontSize: 14,
        bold: true,
        alignment: { horizontal: 'left' }
      },
      encabezado: {
        fontSize: 11,
        bold: true,
        alignment: { horizontal: 'center' },
        fill: { fgColor: { rgb: 'FF808080' } },
        font: { color: { rgb: 'FFFFFFFF' } }
      },
      celda: {
        fontSize: 9,
        alignment: { horizontal: 'left' }
      },
      moneda: {
        fontSize: 9,
        alignment: { horizontal: 'right' },
        numFmt: '$#,##0'
      },
      total: {
        fontSize: 11,
        bold: true,
        alignment: { horizontal: 'right' },
        numFmt: '$#,##0'
      }
    },

    columnas: {
      anchos: {
        descripcion: 60,
        cantidad: 12,
        importe: 18
      },
      visibles: {
        partida: false,
        codigo: false,
        descripcion: true,
        unidad: false,
        cantidad: true,
        precioUnitario: false,
        importe: true
      }
    },

    secciones: {
      encabezado: {
        mostrar: true,
        incluirLogo: false,
        campos: [
          { campo: 'nombre_obra', etiqueta: 'Obra:', fila: 2 },
          { campo: 'cliente', etiqueta: 'Cliente:', fila: 3 }
        ]
      },
      conceptos: {
        inicioFila: 5,
        encabezados: ['Descripción', 'Cantidad', 'Importe']
      },
      totales: {
        mostrar: true,
        campos: [
          { campo: 'costoDirecto', etiqueta: 'Subtotal:', mostrar: true },
          { campo: 'iva', etiqueta: 'IVA (16%):', mostrar: true },
          { campo: 'total', etiqueta: 'TOTAL:', mostrar: true, resaltar: true }
        ]
      },
      piePagina: {
        mostrar: false
      }
    }
  },

  // Plantilla corporativa (personalizable)
  corporativa: {
    nombre: 'Corporativa',
    descripcion: 'Formato con identidad corporativa',

    // Configuración de marca
    marca: {
      empresa: 'Mi Empresa S.A. de C.V.',
      logo: null, // Path al logo o base64
      colores: {
        principal: 'FF003366',
        secundario: 'FF6699CC',
        acento: 'FFFF6600'
      },
      contacto: {
        telefono: '(555) 123-4567',
        email: 'presupuestos@miempresa.com',
        web: 'www.miempresa.com'
      }
    },

    estilos: {
      titulo: {
        fontSize: 18,
        bold: true,
        alignment: { horizontal: 'center' },
        font: { color: { rgb: 'FF003366' } }
      },
      encabezado: {
        fontSize: 11,
        bold: true,
        alignment: { horizontal: 'center' },
        fill: { fgColor: { rgb: 'FF003366' } },
        font: { color: { rgb: 'FFFFFFFF' } }
      },
      celda: {
        fontSize: 10,
        alignment: { horizontal: 'left' },
        borders: {
          top: { style: 'thin', color: { rgb: 'FFE0E0E0' } },
          bottom: { style: 'thin', color: { rgb: 'FFE0E0E0' } },
          left: { style: 'thin', color: { rgb: 'FFE0E0E0' } },
          right: { style: 'thin', color: { rgb: 'FFE0E0E0' } }
        }
      },
      moneda: {
        fontSize: 10,
        alignment: { horizontal: 'right' },
        numFmt: '$#,##0.00'
      },
      total: {
        fontSize: 14,
        bold: true,
        alignment: { horizontal: 'right' },
        fill: { fgColor: { rgb: 'FFFF6600' } },
        font: { color: { rgb: 'FFFFFFFF' } },
        numFmt: '$#,##0.00'
      }
    },

    columnas: {
      anchos: {
        codigo: 15,
        descripcion: 50,
        unidad: 10,
        cantidad: 12,
        precioUnitario: 15,
        importe: 18
      },
      visibles: {
        partida: true,
        codigo: true,
        descripcion: true,
        unidad: true,
        cantidad: true,
        precioUnitario: true,
        importe: true
      }
    },

    secciones: {
      encabezado: {
        mostrar: true,
        incluirLogo: true,
        incluirDatosCorporativos: true,
        campos: [
          { campo: 'folio', etiqueta: 'Folio:', fila: 3 },
          { campo: 'nombre_obra', etiqueta: 'Proyecto:', fila: 4 },
          { campo: 'cliente', etiqueta: 'Cliente:', fila: 5 },
          { campo: 'ubicacion', etiqueta: 'Ubicación:', fila: 6 },
          { campo: 'fecha_elaboracion', etiqueta: 'Fecha:', fila: 7, formato: 'fecha' },
          { campo: 'vigencia', etiqueta: 'Vigencia:', fila: 8 }
        ]
      },
      conceptos: {
        inicioFila: 10,
        encabezados: ['Partida', 'Código', 'Descripción', 'Unidad', 'Cantidad', 'P.U.', 'Importe'],
        agruparPorPartidas: true
      },
      totales: {
        mostrar: true,
        incluirFirmas: true,
        campos: [
          { campo: 'costoDirecto', etiqueta: 'Costo Directo:', mostrar: true },
          { campo: 'indirectos', etiqueta: 'Indirectos', mostrarPorcentaje: true },
          { campo: 'financiamiento', etiqueta: 'Financiamiento', mostrarPorcentaje: true },
          { campo: 'utilidad', etiqueta: 'Utilidad', mostrarPorcentaje: true },
          { campo: 'subtotal', etiqueta: 'Subtotal:', mostrar: true },
          { campo: 'iva', etiqueta: 'IVA', mostrarPorcentaje: true },
          { campo: 'total', etiqueta: 'TOTAL:', mostrar: true, resaltar: true }
        ],
        firmas: [
          { nombre: 'Elaboró', linea: true },
          { nombre: 'Revisó', linea: true },
          { nombre: 'Autorizó', linea: true }
        ]
      },
      piePagina: {
        mostrar: true,
        incluirDatosContacto: true,
        incluirTerminosCondiciones: true,
        texto: 'Este presupuesto tiene una vigencia de 30 días a partir de la fecha de elaboración.'
      }
    }
  }
};

// Función para obtener una plantilla específica
export const getExcelTemplate = (templateName = 'standard') => {
  return excelTemplates[templateName] || excelTemplates.standard;
};

// Función para obtener lista de plantillas disponibles
export const getAvailableTemplates = () => {
  return Object.keys(excelTemplates).map(key => ({
    id: key,
    nombre: excelTemplates[key].nombre,
    descripcion: excelTemplates[key].descripcion
  }));
};

// Función para personalizar una plantilla existente
export const customizeTemplate = (baseTemplate, customizations) => {
  const template = { ...excelTemplates[baseTemplate] };

  // Aplicar personalizaciones
  if (customizations.estilos) {
    template.estilos = { ...template.estilos, ...customizations.estilos };
  }

  if (customizations.columnas) {
    template.columnas = { ...template.columnas, ...customizations.columnas };
  }

  if (customizations.secciones) {
    template.secciones = { ...template.secciones, ...customizations.secciones };
  }

  if (customizations.marca) {
    template.marca = { ...template.marca, ...customizations.marca };
  }

  return template;
};

// Configuración global de Excel
export const excelConfig = {
  // Configuración de archivo
  archivo: {
    nombreBase: 'presupuesto',
    incluirFecha: true,
    incluirFolio: true,
    extension: '.xlsx'
  },

  // Configuración de hoja
  hoja: {
    nombre: 'Presupuesto',
    orientacion: 'portrait', // portrait o landscape
    ajustarAPagina: true,
    margenes: {
      top: 0.75,
      bottom: 0.75,
      left: 0.7,
      right: 0.7,
      header: 0.3,
      footer: 0.3
    }
  },

  // Opciones de formato numérico
  formatos: {
    moneda: {
      simbolo: '$',
      decimales: 2,
      separadorMiles: true
    },
    porcentaje: {
      decimales: 2,
      simbolo: '%'
    },
    numero: {
      decimales: 2,
      separadorMiles: true
    },
    fecha: {
      formato: 'DD/MM/YYYY'
    }
  }
};

export default {
  excelTemplates,
  getExcelTemplate,
  getAvailableTemplates,
  customizeTemplate,
  excelConfig
};